import axios from "axios";
import { api } from "./api_route";


//Case Primary Information Routes --> Asset Details

// =========== GET ALL VEHICLES BY CASE ID ===========
export const getAllVehiclesByCaseId = async (caseDetailsID) => {
  try {
    const response = await axios.get(
      `${api}/case/caseVehicleDetails/all/${caseDetailsID}`
    );

    return {
      success: true,
      data: response.data.data || [],
      assetOwnedBy: response.data.assetOwnedBy || '',
      count: response.data.count || 0,
      message: response.data.message || "Vehicles fetched successfully",
    };
  } catch (error) {
    console.error("Error fetching vehicles:", error);
    return {
      success: false,
      data: [],
      count: 0,
      message: error.response?.data?.message || "Failed to fetch vehicles",
      error: error.response?.data?.error || error.message,
    };
  }
};


// =========== GET SINGLE VEHICLE BY ID ===========
export const getVehicleById = async (vehicleID) => {
  try {
    const response = await axios.get(
      `${api}/case/caseVehicleDetails/${vehicleID}`
    );

    return {
      success: true,
      data: response.data.data,
      // message: response.data.message || "Vehicle fetched successfully",
    };
  } catch (error) {
    console.error("Error fetching vehicle:", error);
    return {
      success: false,
      data: null,
      message: error.response?.data?.message || "Failed to fetch vehicle",
      error: error.response?.data?.error || error.message,
    };
  }
};

// =========== CREATE NEW VEHICLE ===========
export const createVehicle = async (vehicleData) => {
  try {
    const response = await axios.post(
      `${api}/case/caseVehicleDetails`,
      vehicleData
    );

    

    return {
      success: true,
      data: response.data.data,
      message: response.data.message || "Vehicle created successfully",
    };
  } catch (error) {
    console.error("Error creating vehicle:", error);
    return {
      success: false,
      data: null,
      message: error.response?.data?.message || "Failed to create vehicle",
      error: error.response?.data?.error || error.message,
    };
  }
};

// =========== UPDATE VEHICLE ===========
export const updateVehicle = async (vehicleID, vehicleData) => {
  try {
    const response = await axios.put(
      `${api}/case/caseVehicleDetails/${vehicleID}`,
      vehicleData
    );

    return {
      success: true,
      data: response.data.data,
      message: response.data.message || "Vehicle updated successfully",
    };
  } catch (error) {
    console.error("Error updating vehicle:", error);
    return {
      success: false,
      data: null,
      message: error.response?.data?.message || "Failed to update vehicle",
      error: error.response?.data?.error || error.message,
    };
  }
};

// =========== DELETE VEHICLE ===========
export const deleteVehicle = async (vehicleID, updatedBy) => {
  try {
    const response = await axios.delete(
      `${api}/case/caseVehicleDetails/${vehicleID}`,
      { data: { updatedBy } }
    );

    return {
      success: true,
      message: response.data.message || "Vehicle deleted successfully",
    };
  } catch (error) {
    console.error("Error deleting vehicle:", error);
    return {
      success: false,
      message: error.response?.data?.message || "Failed to delete vehicle",
      error: error.response?.data?.error || error.message,
    };
  }
};

// =========== SEARCH VEHICLES ===========
export const searchVehicles = async (caseDetailsID, searchCriteria) => {
  try {
    const response = await axios.post(
      `${api}/case/caseVehicleDetails/search/${caseDetailsID}`,
      searchCriteria
    );

    return {
      success: true,
      data: response.data.data || [],
      count: response.data.count || 0,
      message: response.data.message || "Search completed successfully",
    };
  } catch (error) {
    console.error("Error searching vehicles:", error);
    return {
      success: false,
      data: [],
      count: 0,
      message: error.response?.data?.message || "Failed to search vehicles",
      error: error.response?.data?.error || error.message,
    };
  }
};

// =========== BULK CREATE VEHICLES ===========
export const bulkCreateVehicles = async (vehiclesData) => {
  try {
    const response = await axios.post(
      `${api}/case/caseVehicleDetails/bulk`,
      { vehicles: vehiclesData }
    );

    return {
      success: true,
      data: response.data.data,
      message: response.data.message || "Vehicles created successfully",
    };
  } catch (error) {
    console.error("Error creating bulk vehicles:", error);
    return {
      success: false,
      data: [],
      message: error.response?.data?.message || "Failed to create vehicles",
      error: error.response?.data?.error || error.message,
    };
  }
};

// =========== GET VEHICLES WITH PAGINATION ===========
export const getVehiclesWithPagination = async (caseDetailsID, page = 1, limit = 10) => {
  try {
    const response = await axios.get(
      `${api}/case/caseVehicleDetails/paginated/${caseDetailsID}`,
      { params: { page, limit } }
    );

    return {
      success: true,
      data: response.data.data || [],
      pagination: response.data.pagination || {},
      message: response.data.message || "Vehicles fetched successfully",
    };
  } catch (error) {
    console.error("Error fetching vehicles with pagination:", error);
    return {
      success: false,
      data: [],
      pagination: {},
      message: error.response?.data?.message || "Failed to fetch vehicles",
      error: error.response?.data?.error || error.message,
    };
  }
};

// =========== EXPORT VEHICLES TO EXCEL ===========
export const exportVehiclesToExcel = async (caseDetailsID) => {
  try {
    const response = await axios.get(
      `${api}/case/caseVehicleDetails/export/${caseDetailsID}`,
      { responseType: "blob" }
    );

    return {
      success: true,
      data: response.data,
      message: "Export successful",
    };
  } catch (error) {
    console.error("Error exporting vehicles:", error);
    return {
      success: false,
      data: null,
      message: error.response?.data?.message || "Failed to export vehicles",
      error: error.response?.data?.error || error.message,
    };
  }
};

// =========== HELPER FUNCTIONS ===========


export const formatVehicleData = (data) => {
  const formatted = { ...data };


  if (Array.isArray(formatted.assetAttachmentField)) {
    formatted.assetAttachmentField = formatted.assetAttachmentField.join(",");
  }


  const formatDate = (date) => {
    if (!date) return null;
    if (date instanceof Date) {
      return date.toISOString().split("T")[0];
    }
    return date;
  };

  formatted.assetSeizureDate = formatDate(formatted.assetSeizureDate);
  formatted.assetSaleDate = formatDate(formatted.assetSaleDate);
  formatted.presaleNoticeDate = formatDate(formatted.presaleNoticeDate);
  formatted.postSaleNoticeDate = formatDate(formatted.postSaleNoticeDate);
  formatted.advocateCommAppointedOn = formatDate(formatted.advocateCommAppointedOn);

  return formatted;
};


export const parseAttachmentIds = (attachmentField) => {
  if (!attachmentField || attachmentField.trim() === "") {
    return [];
  }
  return attachmentField
    .split(",")
    .map((id) => id.trim())
    .filter((id) => id !== "");
};


export const validateVehicleData = (data) => {
  const errors = {};

  if (!data.caseDetailsID) {
    errors.caseDetailsID = "Case ID is required";
  }

  if (!data.assetType) {
    errors.assetType = "Asset type is required";
  }



  return {
    isValid: Object.keys(errors).length === 0,
    errors,
  };
};


export const vehicleFilesDownload = async (values) => {
  try {
    const response = await axios.get(`${api}/documents/asset/vehicleEquipment/${values}`, {
      responseType: "blob",
    });

    return response.data;
  } catch (error) {
    return [];
  }
};
